import { StoreAction } from 'types/store';

export const SET_THEME = 'SET_THEME';
export type SetTheme = StoreAction<typeof SET_THEME, object>;
export const setTheme = (theme: object): SetTheme => ({
  type: SET_THEME,
  payload: theme,
});
